import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';
import Rectangle from '../../../../source/js/shared/models/Geometry/Rectangle';

export default class OctagonConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'side_length',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle: Rectangle ): Record<string, Length> {
		const diagonalFactor = 1 + Math.sqrt(2);
		const maximum_side_length = maximum_rectangle.get_shortest_side().in_mm() / diagonalFactor;

		return {
			side_length: new Length( maximum_side_length )
		};
	}

	get_labels(): Record<string, string> {
		const { side_length } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			side_length,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			side_length: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'straight';
	}
}
